import React, { Component } from 'react';
import FilterBasic from '../../basicElement/FilterBasic';
import API_URL from '../../../common/url';

class Filter extends Component {
    handleChange = (params, key) => {
        if (key === 'lineOfBusiness') {
            params.secondLineName = undefined;
            this.props.onChange(params, key);
        } else {
            this.props.onChange(params, key);
        }
    }

    render() {
        const { config, businessList, params, ...rest } = this.props;
        const { lineOfBusiness } = params;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const secondLineOption = [...secondLineSet].map(i => ({ value: i, label: i }));
        const filters = [{
            name: '项目简称',
            key: 'investigation',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'investigationName',
                style: {width: 160},
                placeholder: '输入名称检索',
                params: {limit: 20},
                url: API_URL.investigation.queryInvestigationByName,
                config: { id: 'investigationId', name: 'investigationName' }
            }
        }, {
            name: 'JDE建号申请状态',
            key: 'jdeApplyStatus',
            type: 'select',
            typeProperty: {
                list: [
                    { label: '未申请', value: 'NOT_APPLY' },
                    { label: '待PM审核合同金额', value: 'PM_APPROVAL_CONTRACT_MONEY' },
                    { label: 'PM审核合同金额不通过', value: 'PM_DISAGREE_APPROVAL_CONTRACT_MONEY' },
                    { label: '待FIN审核合同金额', value: 'FIN_APPROVAL_CONTRACT_MONEY' },
                    { label: 'FIN审核合同金额通过', value: 'FIN_AGREE_APPROVAL_CONTRACT_MONEY' },
                    { label: 'FIN审核合同金额不通过', value: 'FIN_DISAGREE_APPROVAL_CONTRACT_MONEY' },
                ],
                style: {width: 160},
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }, {
            name: '执行业务线二级分类',
            key: 'secondLineName',
            type: 'select',
            typeProperty: {
                disabled: !lineOfBusiness,
                list: secondLineOption,
            }
        }];
        return (
            <FilterBasic
                filters={filters}
                params={params}
                {...rest}
                onChange={this.handleChange}
            />
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/contractManagement/terminationApply/Filter.js